import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@environment/environment';

// Suppress Google Maps Places Autocomplete deprecation warning (active until Google formal deprecation)
const originalWarn = console.warn;
console.warn = function (...args: any[]): void {
    if (
        args &&
        typeof args[0] === "string" &&
        args[0].includes("google.maps.places.Autocomplete")
    ) {
        return;
    }
    originalWarn.apply(console, args);
};

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
